import { useEffect, useState } from 'react';
import { getJSON } from './api';
import { PeriodToggle } from './PeriodToggle';
import { StatsTable, Totals } from './StatsTable';
import { RoundsList } from './RoundsList';

// "What this customer played": per-game totals, click a game for its rounds.
export const PlayerGamesPanel = ({ userId }) => {
    const [period, setPeriod] = useState('7d');
    const [data, setData] = useState(null);
    const [game, setGame] = useState(null);
    useEffect(() => {
        setData(null);
        getJSON(`/admin/players/${userId}/games?period=${period}`).then(setData).catch(() => setData({ games: [], totals: {} }));
    }, [userId, period]);
    return (
        <div className="space-y-3" data-testid="player-games-panel">
            <div className="flex flex-wrap items-center gap-3">
                {game && <button type="button" className="text-xs text-zinc-400 hover:text-white" onClick={() => setGame(null)} data-testid="player-games-back">← All games</button>}
                <span className="text-sm font-bold text-white">{game ? game.game_name : 'Games played'}</span>
                <span className="ml-auto"><PeriodToggle value={period} onChange={setPeriod} testid="player-games-period" /></span>
            </div>
            {!data ? <p className="text-xs text-zinc-500 py-4 text-center">Loading…</p> : game ? (
                <RoundsList userId={userId} gameId={game.game_id} period={period} />
            ) : data.games.length === 0 ? (
                <p className="text-xs text-zinc-500 py-4 text-center" data-testid="player-games-empty">No games played in this period.</p>
            ) : (
                <>
                    <Totals t={data.totals} />
                    <StatsTable rows={data.games} labelKey="game_name" labelTitle="Game" onPick={setGame} testid="player-games-table" />
                </>
            )}
        </div>
    );
};
